import React from 'react';
import PropTypes from 'prop-types';

import TextInput from '../../../TextInput';
import SelectCustom from '../../../SelectCustom';
import { FormErrorBlock } from '../../../common/FormErrorBlock';
import { LENGTH_VALUES } from '../../../../constants/validations';
import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';
import { normalizeRelationList } from '../../../../utils/forms/EmergencyContact';

import styles from './styles.styl';

const {
  EMAIL,
  RELATION,
  LAST_NAME,
  FIRST_NAME,
  PHONE_NUMBER,
} = PROFILE_FIELDS_TYPES;

const EmergencyContactRowModeView = ({
  onChange,
  formState,
  relationList,
  formatMessage,
  onEmailChange,
  validateErrors,
  makeProfileField,
  onMobilePhoneChange,
}) => {
  const { email, lastName, relation, firstName, phoneNumber } = formState;

  return (
    <div className={styles.root}>
      <div className={styles.column}>
        {/*     FIRST_NAME     */}
        <TextInput
          {...makeProfileField(FIRST_NAME)}
          value={firstName}
          required={false}
          limit={LENGTH_VALUES.FIRST_NAME.MAX}
        />

        {/*     LAST_NAME     */}
        <TextInput
          {...makeProfileField(LAST_NAME)}
          value={lastName}
          required={false}
          limit={LENGTH_VALUES.LAST_NAME.MAX}
        />
      </div>

      <div className={styles.column}>
        {/*     RELATION     */}
        <div>
          <SelectCustom
            {...makeProfileField(RELATION)}
            value={relation}
            needUpdateDefaultValue
            options={normalizeRelationList(relationList)}
            onChange={data => onChange({ relation: data })}
          />
        </div>

        {/*     PHONE_NUMBER     */}
        <div>
          <TextInput
            {...makeProfileField(PHONE_NUMBER)}
            value={phoneNumber}
            limit={LENGTH_VALUES.EMERGENCY_PHONE.MAX}
            onChange={data => onMobilePhoneChange(data, formatMessage)}
          />
          <FormErrorBlock type={PHONE_NUMBER} errors={validateErrors} />
        </div>
      </div>

      {/*     EMAIL     */}
      <div className={styles.column}>
        <div>
          <TextInput
            {...makeProfileField(EMAIL)}
            value={email}
            onChange={data => onEmailChange(data)}
          />
          <FormErrorBlock
            type={EMAIL}
            errors={
              validateErrors.email && {
                email: formatMessage({
                  id: 'messages.patientNotJoined.errors.emailInvalid',
                }),
              }
            }
          />
        </div>
      </div>
    </div>
  );
};

EmergencyContactRowModeView.propTypes = {
  onChange: PropTypes.func,
  formState: PropTypes.object,
  relationList: PropTypes.array,
  formatMessage: PropTypes.func,
  onEmailChange: PropTypes.func,
  makeProfileField: PropTypes.func,
  validateErrors: PropTypes.object,
  onMobilePhoneChange: PropTypes.func,
};

export default EmergencyContactRowModeView;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/EmergencyContact/EmergencyContactFormSection/EmergencyContactRowModeView.jsx